import { render, staticRenderFns } from "./WxModal.vue?vue&type=template&id=3df5f12b&scoped=true"
import script from "./WxModal.vue?vue&type=script&lang=js"
export * from "./WxModal.vue?vue&type=script&lang=js"
import style0 from "./WxModal.vue?vue&type=style&index=0&id=3df5f12b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df5f12b",
  null
  
)

export default component.exports